import React from 'react';
import TradesList from '@/components/trading/TradesList';

interface UnifiedTradingTabProps {
    status: 'pending' | 'open' | 'closed';
    title: string;
    description: string;
    customerId?: string;
    hideCustomerColumn?: boolean;
    /**
     * Repeat the title above the table. Off by default: the tab this renders in
     * already carries the same label, and the page above that carries the page
     * title, so showing it a third time is noise.
     */
    showHeader?: boolean;
    stickyLayout?: boolean;
}

const UnifiedTradingTab: React.FC<UnifiedTradingTabProps> = ({
    status,
    title,
    description,
    customerId,
    hideCustomerColumn,
    showHeader = false,
    stickyLayout = false,
}) => {
    return (
        <TradesList
            status={status}
            title={title}
            description={description}
            customerId={customerId}
            hideCustomerColumn={hideCustomerColumn}
            showExport={true}
            showRefresh={true}
            showHeader={showHeader}
            stickyLayout={stickyLayout}
        />
    );
};

export default UnifiedTradingTab;
